import { createBEM } from "@/libs";
import { ComponentBase } from "@/types";
import { dateFormat } from "@/utils/tool";
import { Icon } from "../Icon";
import "./index.scss";

export const getStep = (status: string) => {
  switch (status) {
    case "CollectedSuccess":
      return 4;
    case "CollectedFail":
    case "WaitingCollected":
      return 3;
    case "WaitingTransfer":
    case "TransferTimeOut":
    case "AutoCancel":
    case "Manualcancel":
      return 2;
    default:
      return 1;
  }
}

export const stepDescClass = (code: number) =>  {
  if (code === 1) {
    return "success";
  }
  if (code === 0) {
    return "failed";
  }
  if (code === -1) {
    return "normal";
  }
};
export const stepStatus = (status: string, step:number, slot: number) =>  {
  if (slot === 2 && step > 2) {
    return 1;
  }
  if (slot === 3 && step > 3) {
    return 1;
  }
  switch (status) {
    case "CollectedSuccess":
      return 1;
    case "WaitingTransfer":
    case "WaitingCollected":
      return -1;
    case "CollectedFail":
    case "AutoCancel":
    case "Manualcancel":
    case "TransferTimeOut":
      return 0;
    default:
      break;
  }
};
export const stepDesc = (status:string, step:number, slot: number) =>{
  if (slot === 2 && step > 2) {
    return "已确认";
  }
  if (slot === 3 && step > 3) {
    return "已归集";
  }
  switch (status) {
    case "WaitingTransfer":
      return "等待转账";
    case "TransferTimeOut":
      return "转账超时";
    case "WaitingCollected":
      return "等待归集";
    case "CollectedFail":
      return "归集失败";
    case "CollectedSuccess":
      return "订单完成";
    case "AutoCancel":
      return "自动取消";
    case "Manualcancel":
      return "人工取消";
    default:
      break;
  }
}


export interface TradeStepsProps extends ComponentBase.Component {
  status: string;
  createTime: string;
  passageType: string;
}

export const CryptoTradeSteps = ({ status, createTime,passageType }: TradeStepsProps) => {
  const b = createBEM("crypto-trade-steps");

  const step = getStep(status);

  const target = <span className={b("target")}></span>;

  return (
    <div className={b()}>
      <div className={b("item", "first")}>
        <div className={b("up")}>{dateFormat(createTime, "M/D")}</div>
        <div className={b("icon-area")}>
          <Icon
            className={b("target-past")}
            name="step-success"
            size="20px"
          />
        </div>
        <div className={b("down")}>{dateFormat(createTime, "h:m:s")}</div>
      </div>
      <div className={b("item", { onstep: step === 2, past: step > 2 })}>
        <div className={b("up")}>区块确认</div>
        <div className={b("icon-area")}>
          {step > 2 ? (
            <Icon
              className={b("target-past")}
              name="step-success"
              size="20px"
            />
          ) : (
            target
          )}
        </div>
        {step >= 2 && <div className={b("down")}>{stepDesc(status, step, 2)}</div>}
      </div>

      {
        passageType !== "ChangeUsdt" ? (
          <div className={b("item", { onstep: step === 3, past: step > 3 })}>
            <div className={b("up")}>货币归集</div>
            <div className={b("icon-area")}>
              {step > 3 ? (
                <Icon
                  className={b("target-past")}
                  name="step-success"
                  size="20px"
                />
              ) : (
                target
              )}
            </div>
            {step >= 3 && <div className={b("down")}>{stepDesc(status, step, 3)}</div>}
          </div>
        ):null
      }

      <div
        className={b("item", "last", {
          onstep: step === 4,
          past: stepStatus(status, step, 4)
        })}
      >
        <div className={b("up")}>交易完成</div>
        <div className={b("icon-area")}>
          {stepStatus(status, step, 4) ? (
            <Icon
              className={b("target-past")}
              name="step-success"
              size="20px"
            />
          ) : (
            target
          )}
        </div>
        {step >= 4 && <div className={b("down")}>{stepDesc(status, step, 4)}</div>}
      </div>
    </div>
  );
};
